import React, { useState, useEffect, useRef, useCallback } from "react";
import $ from "jquery";
import styled from "styled-components";
import { Toast, Toaster } from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import { useWindowSize } from "./../../hooks";
import ThumbsWrapper from "./../ThumbsWrapper";
import ClockHelper from "./../Animate/clockhelper";
import MagazineTurnElem from "./../MagazineTurnElem";
import { AtSpinnerOverlay, AtSpinner } from "./../AtSpinner";
import MiniCinematic from "./../MiniCinematic";

import { resizeKeepingAspect } from "./../../utils";
import {
  pages,
  fullscreenbtnsrc,
  links,
  magbase,
  paneltogglesrc,
} from "./../../constants";
import { useFullscreen, useToggle } from "react-use";
import ReactGA from "react-ga";
import Api from "./../../api";

const clockHelper = new ClockHelper();
const WholeContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  &:fullscreen {
    background: #2e2f3c !important;
  }
`;
const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(${(props) => props.wid}px + 2rem);
  height: calc(${(props) => props.hgt}px + 1.3rem);
  padding: 1rem;
  box-sizing: border-box;
  background-image: url(${magbase});
  ${(props) =>
    props.center !== 0
      ? "background-image: url(./magazine/base-half.png);background-position:" +
        props.wid / 4 +
        "px 0px;"
      : ""}
  background-repeat: no-repeat;
  background-size: contain;
  transition: background-image 1s, background-position 1s;
  & .magazine {
    margin-left: calc(
      ${(props) => (props.center !== 0 ? (props.center * props.wid) / 4 : 0)}px
    );
    transition: margin-left 0.5s;
  }
  padding: 0;
  & > div:nth-child(1) {
    position: absolute;
    margin: 0.65rem 1rem;
  }
`;

const LoadingPlaceholderDiv = styled.div`
  width: calc(${(props) => props.wid / 2}px);
  height: calc(${(props) => props.hgt}px);
  background: #060219;
  color: hsl(203, 27%, 22%);
`;
const LinksFrame = styled.div`
  z-index: 2;
  position: absolute;
  width: calc(100% - 2rem);
  height: calc(100% - 1.3rem);
  box-sizing: border-box;
  margin: 0.65rem 1rem;
  pointer-events: none;
  background: transparent;
  overflow: hidden;
`;
const ZoomBtnContainer = styled.div`
  position: fixed;
  padding: 0.5rem 1rem;
  width: 100vw;
  box-sizing: border-box;
  /* border-radius: 0.25rem; */
  z-index: 1;
  pointer-events: none;
  & :last-child {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  & :first-child {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  & > img {
    float: right;
    opacity: 0.3;
    /* border-radius: 0.5rem; */
    background: rgba(180, 185, 203, 0.5);
    /* margin: 0.2rem; */
    padding: 0.1rem;
    pointer-events: all;
  }

  & > img:hover {
    opacity: 1;
  }
`;

const Link = styled.div`
  position: absolute;
  z-index: 10;
  color: transparent;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background: transparent;
  cursor: pointer;
  pointer-events: all;
  ${(props) => (props.rotate ? "transform:rotate(" + props.rotate + ");" : "")}
  ${(props) => (props.active ? "" : "display:none;")} /* opacity: 0.5; */
`;

const PeelBlocker = styled.div`
  top: 0;
  left: 0;
  height: 100%;
  width: 50%;
  position: absolute;
  z-index: 10;
  pointer-events: all;
`;
const Video = styled.video`
  z-index: 10;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 76.9%;
  display: ${(props) => (props.show ? "block" : "none")};
  -webkit-mask-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.5, rgba(0, 0, 0, 1)),
    color-stop(0.75, rgba(0, 0, 0, 1)),
    color-stop(1, rgba(0, 0, 0, 0))
  );
`;

const MaskImage = styled.img`
  pointer-events: none;
  z-index: 1;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 0.65rem 1rem;
  display: ${(props) => (props.show ? "block" : "none")};
`;
const Clockcanvas = styled.canvas`
  position: absolute;
  left: 794px;
  top: 520px;
  z-index: 2;
  width: 14%;
  left: 26.5%;
  top: 59.05%;
  transform: scale(0.95) rotateZ(56deg);
  display: ${(props) => (props.show ? "block" : "none")};
`;
const QR = styled.img`
  position: absolute;
  z-index: 10;
  top: 6.5%;
  left: 69.5%;
  width: 7%;
  height: 7%;
  background: transparent;
  height: auto !important;
  opacity: 0;
  transform: rotate(29deg);
  cursor: pointer;
`;

const MagNavigator = styled.img`
  width: 32px;
  z-index: 15;
  top: 50%;
  pointer-events: all;
  cursor: pointer;

  position: absolute;
  border-radius: 50%;
  background: #b4b9cb;
  opacity: 0.4;

  &:hover {
    opacity: 0.9;
  }

  &.left {
    left: 0.5rem;
    transform: translate(0, -50%) rotate(90deg);
  }
  &.right {
    left: calc(100% - 0.5rem);
    transform: translate(-100%, -50%) rotate(270deg);
  }
`;

function getJsonFromUrl(url) {
  if (!url) url = window.location.search;
  var query = url.substr(1);
  var result = {};
  query.split("&").forEach(function (part) {
    var item = part.split("=");
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
}
const copyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};
const Turn = () => {
  const [center, setcenter] = useState(0);
  const [dims, setdims] = useState(null);
  const [activePage, setactivePage] = useState(1);
  const [clockinit, setclockinit] = useState(false);
  const page = getJsonFromUrl().page;
  const isPageLocked = !!(page || window.location.pathname.match(/\/\d+/));
  const [turnPage, setturnPage] = useState();
  const [loadImageArr, setloadImageArr] = useState([]);
  const [firstTurn, setfirstTurn] = useState(true);
  const [showToast, setshowToast] = useState(true);
  const [toastProps, setToastProps] = useState(null);
  const [showcinematic, setshowcinematic] = useState(false);
  const clockcanvas = useRef(null);
  const videoref = useRef(null);
  const audioref = useRef(null);
  const containerref = useRef(null);
  const [show, toggle] = useToggle(false);
  const isFullscreen = useFullscreen(containerref, show, {
    onClose: () => toggle(false),
  });

  const windowsize = useWindowSize();

  const { width, height } = resizeKeepingAspect(
    { width: 1920, height: 1080 },
    { width: window.innerWidth - 32, height: window.innerHeight - 32 }
  );

  //set options for flipbook
  const options = {
    width: Number(width),
    height: Number(height),
    autoCenter: true,
    display: "double",
    duration: 1000,
    acceleration: true,
    elevation: 200,
    page: page ? parseInt(page) * 2 : 2,
    gradients: !$.isTouch,
    turnCorners: isPageLocked ? "" : "bl,br",
    when: {
      turned: function (e, page) {
        ReactGA.modalview("Turnedtopage " + Math.trunc(page / 2));
        if (Math.trunc(page / 2) === 13) {
          setshowcinematic(true);
        } else {
          setshowcinematic(false);
        }
      },
      turning: function (e, page, view) {
        if (page === 1) {
          page === 1 ? setcenter(-1) : setcenter(1);
        } else {
          setcenter(0);
        }
        if (Math.trunc(page / 2) !== 13) {
          setshowcinematic(false);
        } else {
          setshowcinematic(true);
        }
        let videoelem = document.getElementById("teaVideo");
        if (videoelem && videoelem.currentTime <= 0) videoelem.play();

        setactivePage(Math.trunc(page / 2));
      },
      first: function (e, page) {
        // console.log("first");
        // setcenter(true);
      },
      start: function (event, pageObject, corner) {
        // if (corner === "tr") {
        //     console.log("Triggeres ", corner);
        //     event.preventDefault();
        // }
        //     let arr = [2, 3];
        //     let viewarr = $(this).turn("view");
        //     let isfirst = (viewarr[0]==arr[0]) && (viewarr[1]==arr[1]);
        //     if (isfirst && (corner == "tl" || corner == "bl")) {
        //         console.log("Triggeres ",corner)
        //     event.preventDefault();
        //   }
      },
    },
  };

  //effects

  useEffect(() => {
    let emptyarr = new Array(pages.length).fill(0);
    setloadImageArr([...emptyarr]);
  }, [pages]);

  useEffect(() => {
    let dimobj = resizeKeepingAspect(
      { width: 1920, height: 1080 },
      { width: window.innerWidth - 32, height: window.innerHeight - 32 }
    );
    setdims(dimobj);
  }, [windowsize]);

  useEffect(() => {
    if (clockcanvas !== null && clockcanvas.current) {
      clockHelper.initClock(clockcanvas.current);
      setclockinit(true);
    }
  }, [clockcanvas]);

  useEffect(() => {
    if (!clockinit && activePage !== 1) {
      clockHelper.initClock(clockcanvas.current);
      setclockinit(true);
    }
    if (activePage !== 13) {
      setshowcinematic(false);
    }
    if (activePage > 1 && !isPageLocked) {
      videoref.current.play().catch(() => {});
    }
  }, [activePage]);

  useEffect(() => {
    if (isPageLocked) return;
    const isIpad = navigator.userAgent.match(/iPad/i);

    if (isIpad) return;
    if (firstTurn && activePage === 1) {
    } else if (firstTurn) {
      setfirstTurn(false);
      audioref.current.play().catch(() => {});
    } else {
      const p = audioref.current.play();
      if (p !== undefined) {
        p.then(() => {
          audioref.current.pause();
          audioref.current.currentTime = 0;
          audioref.current.play();
        }).catch(() => {});
      } else {
        audioref.current.pause();
        audioref.current.currentTime = 0;
        audioref.current.play();
      }
    }
  }, [activePage]);

  useEffect(() => {
    if (loadImageArr.length > 0) {
      if (
        loadImageArr[1] === 1 &&
        loadImageArr[2] === 1 &&
        loadImageArr[3] === 1 &&
        loadImageArr[4] === 1 &&
        loadImageArr[5] === 1 &&
        loadImageArr[6] === 1
      ) {
        setshowToast(false);
      }
    }
  }, [loadImageArr]);

  const turntopage = (truncatedindex) => {
    let pageindex = truncatedindex === 0 ? 2 : truncatedindex * 2;
    setturnPage(pageindex);
    setTimeout(() => {
      setturnPage(-1);
    }, 50);
  };

  const clickAudioHandler = () => {
    // if(audioref.current.currentTime <= 0){
    // const isIpad = navigator.userAgent.match(/iPad/i)
    // console.log(isIpad)
    // if(isIpad) return;
    // audioref.current.pause();
    // audioref.current.currentTime = 0;
    // audioref.current.play();
    // }
  };

  const handleLinkClick = (e, data) => {
    const { link, action, page, download, self, redirectsession } = data[0];
    e.preventDefault();
    e.stopPropagation();
    let newlink = link;
    if (redirectsession) {
      newlink = link + "?beyonddreamssession=" + Api.getSessionKey();
    }
    if (self) {
      window.open(newlink, "_self");
      if (action) {
        ReactGA.event({
          category: "Links",
          action: "Download",
          value: newlink,
          label: newlink,
        });
        Api.logData(action, "Download");
      }

      return;
    }
    if (!download) {
      window.open(newlink);
      if (action) {
        ReactGA.event({
          category: "Links",
          action: "Click",
          value: newlink,
          label: newlink,
        });
        Api.logData(action, "page=" + page);
      }
    } else {
      var tag = document.createElement("a");
      let image = document.createElement("img");
      tag.appendChild(image);
      image.src = link;

      tag.href = link;
      tag.download = download;
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
    }
  };

  const handleImageLoad = (index) => {
    let newarr = [...loadImageArr];
    newarr[index] = 1;
    setloadImageArr([...newarr]);
  };

  const getImage = (index) => {
    let conditionmet =
      index <= 2 ||
      (index > 2 &&
        (loadImageArr[index - 2] === 1 || loadImageArr[index - 1] === 1));
    return conditionmet ? (
      <img
        src={pages[index]}
        alt=""
        onLoad={() => handleImageLoad(index)}
      ></img>
    ) : (
      <LoadingPlaceholderDiv wid={dims.width} hgt={dims.height}>
        <AtSpinner className="smallloader" size="md"></AtSpinner>
      </LoadingPlaceholderDiv>
    );
  };

  return (
    <React.Fragment>
      <WholeContainer ref={containerref}>
        <ZoomBtnContainer isFullscreen={true}>
          <img
            src={isFullscreen ? fullscreenbtnsrc[1] : fullscreenbtnsrc[0]}
            onClick={() => toggle()}
          ></img>
          <img
            src="./magazine/icons/decrease-height.svg"
            onClick={() => {
              window.open(
                "https://beyonddreamsassets.explorug.online/1/assets/B+E+Y+O+N+D++D+R+E+A+M+S+-+Issue+1.pdf",
                "_self"
              );
              ReactGA.event({
                category: "Links",
                action: "Download",
                value:
                  "https://beyonddreamsassets.explorug.online/1/assets/B+E+Y+O+N+D++D+R+E+A+M+S+-+Issue+1.pdf",
                label:
                  "https://beyonddreamsassets.explorug.online/1/assets/B+E+Y+O+N+D++D+R+E+A+M+S+-+Issue+1.pdf",
              });
            }}
          ></img>
        </ZoomBtnContainer>
        {options != {} && dims && (
          <Container
            isFullscreen={isFullscreen}
            optionwid={0}
            wid={dims.width}
            hgt={dims.height}
            center={center}
          >
            <MagazineTurnElem
              options={options}
              className="magazine"
              turnPage={turnPage}
              clickAudioHandler={clickAudioHandler}
              disabled={isPageLocked}
            >
              {pages.map((page, index) => (
                <div key={index} className="page">
                  {getImage(index)}
                  {index === 13 && loadImageArr[13] === 1 && (
                    <Link
                      top="76%"
                      left="29.6%"
                      width="8%"
                      height="2%"
                      active={true}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        copyToClipboard("EABB2E");
                        setToastProps({
                          message: "Access code copied to clipboard",
                        });
                      }}
                    ></Link>
                  )}
                  {index === 19 && loadImageArr[19] === 1 && (
                    <QR
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        window.open("https://explor.ug/seashore");
                      }}
                      src="./magazine/qr.png"
                    ></QR>
                  )}
                  {index === 19 && (
                    <Video
                      show={loadImageArr[20] === 1}
                      id="teaVideo"
                      ref={videoref}
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source
                        src="https://beyonddreamsassets.explorug.online/1/assets/p10-Anim03.mp4"
                        type="video/mp4"
                      />
                      <source
                        src="https://beyonddreamsassets.explorug.online/1/assets/p10-Anim03.ogv"
                        type="video/ogv"
                      />
                    </Video>
                  )}
                  {index === 20 && (
                    <Clockcanvas
                      show={loadImageArr[20] === 1}
                      ref={clockcanvas}
                      className="clockcanvas"
                    ></Clockcanvas>
                  )}
                </div>
              ))}
            </MagazineTurnElem>
            <LinksFrame>
              {activePage === 1 && <PeelBlocker />}
              {activePage !== 1 && page == undefined && (
                <MagNavigator
                  src={paneltogglesrc[0]}
                  className="left"
                  onClick={() => turntopage(activePage - 1)}
                />
              )}
              {activePage !== Math.trunc(pages.length / 2) &&
                page == undefined && (
                  <MagNavigator
                    src={paneltogglesrc[0]}
                    className="right"
                    onClick={() => turntopage(activePage + 1)}
                  />
                )}
              {links.map((eachlink, index) => (
                <Link
                  key={index}
                  active={activePage === eachlink[0].page}
                  top={eachlink[0].top}
                  left={eachlink[0].left}
                  width={eachlink[0].width}
                  height={eachlink[0].height}
                  rotate={eachlink[0].rotate}
                  onClick={(e) => handleLinkClick(e, eachlink)}
                >
                  Link
                </Link>
              ))}
            </LinksFrame>
            <MaskImage
              show={
                showcinematic &&
                loadImageArr[25] === 1 &&
                loadImageArr[26] === 1
              }
              src="./magazine/13 - Toplayer.png"
              alt="mag"
            />
            <MiniCinematic
              show={
                showcinematic &&
                loadImageArr[25] === 1 &&
                loadImageArr[26] === 1
              }
            />
            <AtSpinnerOverlay show={showToast} />
          </Container>
        )}
        <Toaster position="bottom">
          {toastProps && (
            <Toast
              timeout={3000}
              message={toastProps.message}
              intent="none"
              onDismiss={() => setToastProps(null)}
            />
          )}
        </Toaster>
      </WholeContainer>
      <ThumbsWrapper
        showToast={showToast}
        activePage={activePage}
        triggerPage={turntopage}
        clickAudioHandler={clickAudioHandler}
        page={page}
      />
      <audio ref={audioref}>
        <source src="./magazine/flip.mp3" type="audio/mp3" />
      </audio>
    </React.Fragment>
  );
};

export default Turn;
